export default {
    "name": "GetPoiFilters",
    "kind": "HoudiniQuery",
    "hash": "470c15fd9876ed5000d36e745ea5e008c0434dee46f090d6497e6f8e9f8be33d",

    "raw": `query GetPoiFilters {
  getPoiFilters {
    filtersV2 {
      REST_STOP {
        id
        name
        filter {
          ...FilterFragment
          __typename
        }
        notice
      }
      PARKING {
        id
        name
        filter {
          ...FilterFragment
          __typename
        }
        notice
      }
      EV_SERVICE {
        id
        name
        filter {
          ...FilterFragment
          __typename
        }
        notice
      }
      SERVICE_GAS_STATION {
        id
        name
        filter {
          ...FilterFragment
          __typename
        }
        notice
      }
      TOURISM {
        id
        name
        filter {
          ...FilterFragment
          __typename
        }
        notice
      }
      RESTAURANT {
        id
        name
        filter {
          ...FilterFragment
          __typename
        }
        notice
      }
      ACCOMMODATION {
        name
        id
        filter {
          ...FilterFragment
          __typename
        }
        notice
      }
    }
    currency
  }
}

fragment FilterFragment on Filter {
  ... on SwitchFilter {
    component
    switchDefaultValue
  }
  ... on SingleSliderFilter {
    component
    min
    max
    singleSliderDefaultValue
  }
  ... on MultiSliderFilter {
    component
    min
    max
    multiSliderDefaultValue
  }
  ... on MultiSelectFilter {
    component
    multiSelectDefaultValue
    options {
      id
      name
    }
  }
  ... on DateRangeFilter {
    component
    dateRangeDefaultValue {
      startDate
      endDate
    }
  }
  __typename
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "getPoiFilters": {
                "type": "GetPoiFilters",
                "keyRaw": "getPoiFilters",

                "selection": {
                    "fields": {
                        "filtersV2": {
                            "type": "PoiFilters",
                            "keyRaw": "filtersV2",

                            "selection": {
                                "fields": {
                                    "REST_STOP": {
                                        "type": "PoiFilter",
                                        "keyRaw": "REST_STOP",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "PoiFilterId",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "filter": {
                                                    "type": "Filter",
                                                    "keyRaw": "filter",

                                                    "selection": {
                                                        "fields": {
                                                            "__typename": {
                                                                "type": "String",
                                                                "keyRaw": "__typename",
                                                                "visible": true
                                                            }
                                                        },

                                                        "abstractFields": {
                                                            "fields": {
                                                                "SwitchFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "switchDefaultValue": {
                                                                        "type": "Boolean",
                                                                        "keyRaw": "switchDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "SingleSliderFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "min": {
                                                                        "type": "Int",
                                                                        "keyRaw": "min",
                                                                        "visible": true
                                                                    },

                                                                    "max": {
                                                                        "type": "Int",
                                                                        "keyRaw": "max",
                                                                        "visible": true
                                                                    },

                                                                    "singleSliderDefaultValue": {
                                                                        "type": "Int",
                                                                        "keyRaw": "singleSliderDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "MultiSliderFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "min": {
                                                                        "type": "Int",
                                                                        "keyRaw": "min",
                                                                        "visible": true
                                                                    },

                                                                    "max": {
                                                                        "type": "Int",
                                                                        "keyRaw": "max",
                                                                        "visible": true
                                                                    },

                                                                    "multiSliderDefaultValue": {
                                                                        "type": "Int",
                                                                        "keyRaw": "multiSliderDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "MultiSelectFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "multiSelectDefaultValue": {
                                                                        "type": "OptionId",
                                                                        "keyRaw": "multiSelectDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "options": {
                                                                        "type": "MultiSelectOption",
                                                                        "keyRaw": "options",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "id": {
                                                                                    "type": "OptionId",
                                                                                    "keyRaw": "id",
                                                                                    "visible": true
                                                                                },

                                                                                "name": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "name",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "DateRangeFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "dateRangeDefaultValue": {
                                                                        "type": "DateRange",
                                                                        "keyRaw": "dateRangeDefaultValue",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "startDate": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "startDate",
                                                                                    "nullable": true,
                                                                                    "visible": true
                                                                                },

                                                                                "endDate": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "endDate",
                                                                                    "nullable": true,
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "typeMap": {}
                                                        },

                                                        "fragments": {
                                                            "FilterFragment": {
                                                                "arguments": {}
                                                            }
                                                        }
                                                    },

                                                    "abstract": true,
                                                    "visible": true
                                                },

                                                "notice": {
                                                    "type": "String",
                                                    "keyRaw": "notice",
                                                    "nullable": true,
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "PARKING": {
                                        "type": "PoiFilter",
                                        "keyRaw": "PARKING",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "PoiFilterId",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "filter": {
                                                    "type": "Filter",
                                                    "keyRaw": "filter",

                                                    "selection": {
                                                        "fields": {
                                                            "__typename": {
                                                                "type": "String",
                                                                "keyRaw": "__typename",
                                                                "visible": true
                                                            }
                                                        },

                                                        "abstractFields": {
                                                            "fields": {
                                                                "SwitchFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "switchDefaultValue": {
                                                                        "type": "Boolean",
                                                                        "keyRaw": "switchDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "SingleSliderFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "min": {
                                                                        "type": "Int",
                                                                        "keyRaw": "min",
                                                                        "visible": true
                                                                    },

                                                                    "max": {
                                                                        "type": "Int",
                                                                        "keyRaw": "max",
                                                                        "visible": true
                                                                    },

                                                                    "singleSliderDefaultValue": {
                                                                        "type": "Int",
                                                                        "keyRaw": "singleSliderDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "MultiSliderFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "min": {
                                                                        "type": "Int",
                                                                        "keyRaw": "min",
                                                                        "visible": true
                                                                    },

                                                                    "max": {
                                                                        "type": "Int",
                                                                        "keyRaw": "max",
                                                                        "visible": true
                                                                    },

                                                                    "multiSliderDefaultValue": {
                                                                        "type": "Int",
                                                                        "keyRaw": "multiSliderDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "MultiSelectFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "multiSelectDefaultValue": {
                                                                        "type": "OptionId",
                                                                        "keyRaw": "multiSelectDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "options": {
                                                                        "type": "MultiSelectOption",
                                                                        "keyRaw": "options",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "id": {
                                                                                    "type": "OptionId",
                                                                                    "keyRaw": "id",
                                                                                    "visible": true
                                                                                },

                                                                                "name": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "name",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "DateRangeFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "dateRangeDefaultValue": {
                                                                        "type": "DateRange",
                                                                        "keyRaw": "dateRangeDefaultValue",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "startDate": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "startDate",
                                                                                    "nullable": true,
                                                                                    "visible": true
                                                                                },

                                                                                "endDate": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "endDate",
                                                                                    "nullable": true,
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "typeMap": {}
                                                        },

                                                        "fragments": {
                                                            "FilterFragment": {
                                                                "arguments": {}
                                                            }
                                                        }
                                                    },

                                                    "abstract": true,
                                                    "visible": true
                                                },

                                                "notice": {
                                                    "type": "String",
                                                    "keyRaw": "notice",
                                                    "nullable": true,
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "EV_SERVICE": {
                                        "type": "PoiFilter",
                                        "keyRaw": "EV_SERVICE",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "PoiFilterId",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "filter": {
                                                    "type": "Filter",
                                                    "keyRaw": "filter",

                                                    "selection": {
                                                        "fields": {
                                                            "__typename": {
                                                                "type": "String",
                                                                "keyRaw": "__typename",
                                                                "visible": true
                                                            }
                                                        },

                                                        "abstractFields": {
                                                            "fields": {
                                                                "SwitchFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "switchDefaultValue": {
                                                                        "type": "Boolean",
                                                                        "keyRaw": "switchDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "SingleSliderFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "min": {
                                                                        "type": "Int",
                                                                        "keyRaw": "min",
                                                                        "visible": true
                                                                    },

                                                                    "max": {
                                                                        "type": "Int",
                                                                        "keyRaw": "max",
                                                                        "visible": true
                                                                    },

                                                                    "singleSliderDefaultValue": {
                                                                        "type": "Int",
                                                                        "keyRaw": "singleSliderDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "MultiSliderFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "min": {
                                                                        "type": "Int",
                                                                        "keyRaw": "min",
                                                                        "visible": true
                                                                    },

                                                                    "max": {
                                                                        "type": "Int",
                                                                        "keyRaw": "max",
                                                                        "visible": true
                                                                    },

                                                                    "multiSliderDefaultValue": {
                                                                        "type": "Int",
                                                                        "keyRaw": "multiSliderDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "MultiSelectFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "multiSelectDefaultValue": {
                                                                        "type": "OptionId",
                                                                        "keyRaw": "multiSelectDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "options": {
                                                                        "type": "MultiSelectOption",
                                                                        "keyRaw": "options",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "id": {
                                                                                    "type": "OptionId",
                                                                                    "keyRaw": "id",
                                                                                    "visible": true
                                                                                },

                                                                                "name": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "name",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "DateRangeFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "dateRangeDefaultValue": {
                                                                        "type": "DateRange",
                                                                        "keyRaw": "dateRangeDefaultValue",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "startDate": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "startDate",
                                                                                    "nullable": true,
                                                                                    "visible": true
                                                                                },

                                                                                "endDate": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "endDate",
                                                                                    "nullable": true,
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "typeMap": {}
                                                        },

                                                        "fragments": {
                                                            "FilterFragment": {
                                                                "arguments": {}
                                                            }
                                                        }
                                                    },

                                                    "abstract": true,
                                                    "visible": true
                                                },

                                                "notice": {
                                                    "type": "String",
                                                    "keyRaw": "notice",
                                                    "nullable": true,
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "SERVICE_GAS_STATION": {
                                        "type": "PoiFilter",
                                        "keyRaw": "SERVICE_GAS_STATION",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "PoiFilterId",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "filter": {
                                                    "type": "Filter",
                                                    "keyRaw": "filter",

                                                    "selection": {
                                                        "fields": {
                                                            "__typename": {
                                                                "type": "String",
                                                                "keyRaw": "__typename",
                                                                "visible": true
                                                            }
                                                        },

                                                        "abstractFields": {
                                                            "fields": {
                                                                "SwitchFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "switchDefaultValue": {
                                                                        "type": "Boolean",
                                                                        "keyRaw": "switchDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "SingleSliderFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "min": {
                                                                        "type": "Int",
                                                                        "keyRaw": "min",
                                                                        "visible": true
                                                                    },

                                                                    "max": {
                                                                        "type": "Int",
                                                                        "keyRaw": "max",
                                                                        "visible": true
                                                                    },

                                                                    "singleSliderDefaultValue": {
                                                                        "type": "Int",
                                                                        "keyRaw": "singleSliderDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "MultiSliderFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "min": {
                                                                        "type": "Int",
                                                                        "keyRaw": "min",
                                                                        "visible": true
                                                                    },

                                                                    "max": {
                                                                        "type": "Int",
                                                                        "keyRaw": "max",
                                                                        "visible": true
                                                                    },

                                                                    "multiSliderDefaultValue": {
                                                                        "type": "Int",
                                                                        "keyRaw": "multiSliderDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "MultiSelectFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "multiSelectDefaultValue": {
                                                                        "type": "OptionId",
                                                                        "keyRaw": "multiSelectDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "options": {
                                                                        "type": "MultiSelectOption",
                                                                        "keyRaw": "options",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "id": {
                                                                                    "type": "OptionId",
                                                                                    "keyRaw": "id",
                                                                                    "visible": true
                                                                                },

                                                                                "name": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "name",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "DateRangeFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "dateRangeDefaultValue": {
                                                                        "type": "DateRange",
                                                                        "keyRaw": "dateRangeDefaultValue",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "startDate": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "startDate",
                                                                                    "nullable": true,
                                                                                    "visible": true
                                                                                },

                                                                                "endDate": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "endDate",
                                                                                    "nullable": true,
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "typeMap": {}
                                                        },

                                                        "fragments": {
                                                            "FilterFragment": {
                                                                "arguments": {}
                                                            }
                                                        }
                                                    },

                                                    "abstract": true,
                                                    "visible": true
                                                },

                                                "notice": {
                                                    "type": "String",
                                                    "keyRaw": "notice",
                                                    "nullable": true,
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "TOURISM": {
                                        "type": "PoiFilter",
                                        "keyRaw": "TOURISM",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "PoiFilterId",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "filter": {
                                                    "type": "Filter",
                                                    "keyRaw": "filter",

                                                    "selection": {
                                                        "fields": {
                                                            "__typename": {
                                                                "type": "String",
                                                                "keyRaw": "__typename",
                                                                "visible": true
                                                            }
                                                        },

                                                        "abstractFields": {
                                                            "fields": {
                                                                "SwitchFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "switchDefaultValue": {
                                                                        "type": "Boolean",
                                                                        "keyRaw": "switchDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "SingleSliderFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "min": {
                                                                        "type": "Int",
                                                                        "keyRaw": "min",
                                                                        "visible": true
                                                                    },

                                                                    "max": {
                                                                        "type": "Int",
                                                                        "keyRaw": "max",
                                                                        "visible": true
                                                                    },

                                                                    "singleSliderDefaultValue": {
                                                                        "type": "Int",
                                                                        "keyRaw": "singleSliderDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "MultiSliderFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "min": {
                                                                        "type": "Int",
                                                                        "keyRaw": "min",
                                                                        "visible": true
                                                                    },

                                                                    "max": {
                                                                        "type": "Int",
                                                                        "keyRaw": "max",
                                                                        "visible": true
                                                                    },

                                                                    "multiSliderDefaultValue": {
                                                                        "type": "Int",
                                                                        "keyRaw": "multiSliderDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "MultiSelectFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "multiSelectDefaultValue": {
                                                                        "type": "OptionId",
                                                                        "keyRaw": "multiSelectDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "options": {
                                                                        "type": "MultiSelectOption",
                                                                        "keyRaw": "options",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "id": {
                                                                                    "type": "OptionId",
                                                                                    "keyRaw": "id",
                                                                                    "visible": true
                                                                                },

                                                                                "name": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "name",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "DateRangeFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "dateRangeDefaultValue": {
                                                                        "type": "DateRange",
                                                                        "keyRaw": "dateRangeDefaultValue",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "startDate": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "startDate",
                                                                                    "nullable": true,
                                                                                    "visible": true
                                                                                },

                                                                                "endDate": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "endDate",
                                                                                    "nullable": true,
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "typeMap": {}
                                                        },

                                                        "fragments": {
                                                            "FilterFragment": {
                                                                "arguments": {}
                                                            }
                                                        }
                                                    },

                                                    "abstract": true,
                                                    "visible": true
                                                },

                                                "notice": {
                                                    "type": "String",
                                                    "keyRaw": "notice",
                                                    "nullable": true,
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "RESTAURANT": {
                                        "type": "PoiFilter",
                                        "keyRaw": "RESTAURANT",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "PoiFilterId",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "filter": {
                                                    "type": "Filter",
                                                    "keyRaw": "filter",

                                                    "selection": {
                                                        "fields": {
                                                            "__typename": {
                                                                "type": "String",
                                                                "keyRaw": "__typename",
                                                                "visible": true
                                                            }
                                                        },

                                                        "abstractFields": {
                                                            "fields": {
                                                                "SwitchFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "switchDefaultValue": {
                                                                        "type": "Boolean",
                                                                        "keyRaw": "switchDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "SingleSliderFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "min": {
                                                                        "type": "Int",
                                                                        "keyRaw": "min",
                                                                        "visible": true
                                                                    },

                                                                    "max": {
                                                                        "type": "Int",
                                                                        "keyRaw": "max",
                                                                        "visible": true
                                                                    },

                                                                    "singleSliderDefaultValue": {
                                                                        "type": "Int",
                                                                        "keyRaw": "singleSliderDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "MultiSliderFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "min": {
                                                                        "type": "Int",
                                                                        "keyRaw": "min",
                                                                        "visible": true
                                                                    },

                                                                    "max": {
                                                                        "type": "Int",
                                                                        "keyRaw": "max",
                                                                        "visible": true
                                                                    },

                                                                    "multiSliderDefaultValue": {
                                                                        "type": "Int",
                                                                        "keyRaw": "multiSliderDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "MultiSelectFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "multiSelectDefaultValue": {
                                                                        "type": "OptionId",
                                                                        "keyRaw": "multiSelectDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "options": {
                                                                        "type": "MultiSelectOption",
                                                                        "keyRaw": "options",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "id": {
                                                                                    "type": "OptionId",
                                                                                    "keyRaw": "id",
                                                                                    "visible": true
                                                                                },

                                                                                "name": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "name",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "DateRangeFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "dateRangeDefaultValue": {
                                                                        "type": "DateRange",
                                                                        "keyRaw": "dateRangeDefaultValue",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "startDate": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "startDate",
                                                                                    "nullable": true,
                                                                                    "visible": true
                                                                                },

                                                                                "endDate": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "endDate",
                                                                                    "nullable": true,
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "typeMap": {}
                                                        },

                                                        "fragments": {
                                                            "FilterFragment": {
                                                                "arguments": {}
                                                            }
                                                        }
                                                    },

                                                    "abstract": true,
                                                    "visible": true
                                                },

                                                "notice": {
                                                    "type": "String",
                                                    "keyRaw": "notice",
                                                    "nullable": true,
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "ACCOMMODATION": {
                                        "type": "PoiFilter",
                                        "keyRaw": "ACCOMMODATION",

                                        "selection": {
                                            "fields": {
                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "PoiFilterId",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "filter": {
                                                    "type": "Filter",
                                                    "keyRaw": "filter",

                                                    "selection": {
                                                        "fields": {
                                                            "__typename": {
                                                                "type": "String",
                                                                "keyRaw": "__typename",
                                                                "visible": true
                                                            }
                                                        },

                                                        "abstractFields": {
                                                            "fields": {
                                                                "SwitchFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "switchDefaultValue": {
                                                                        "type": "Boolean",
                                                                        "keyRaw": "switchDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "SingleSliderFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "min": {
                                                                        "type": "Int",
                                                                        "keyRaw": "min",
                                                                        "visible": true
                                                                    },

                                                                    "max": {
                                                                        "type": "Int",
                                                                        "keyRaw": "max",
                                                                        "visible": true
                                                                    },

                                                                    "singleSliderDefaultValue": {
                                                                        "type": "Int",
                                                                        "keyRaw": "singleSliderDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "MultiSliderFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "min": {
                                                                        "type": "Int",
                                                                        "keyRaw": "min",
                                                                        "visible": true
                                                                    },

                                                                    "max": {
                                                                        "type": "Int",
                                                                        "keyRaw": "max",
                                                                        "visible": true
                                                                    },

                                                                    "multiSliderDefaultValue": {
                                                                        "type": "Int",
                                                                        "keyRaw": "multiSliderDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "MultiSelectFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "multiSelectDefaultValue": {
                                                                        "type": "OptionId",
                                                                        "keyRaw": "multiSelectDefaultValue",
                                                                        "visible": true
                                                                    },

                                                                    "options": {
                                                                        "type": "MultiSelectOption",
                                                                        "keyRaw": "options",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "id": {
                                                                                    "type": "OptionId",
                                                                                    "keyRaw": "id",
                                                                                    "visible": true
                                                                                },

                                                                                "name": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "name",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "DateRangeFilter": {
                                                                    "component": {
                                                                        "type": "FilterComponentType",
                                                                        "keyRaw": "component",
                                                                        "visible": true
                                                                    },

                                                                    "dateRangeDefaultValue": {
                                                                        "type": "DateRange",
                                                                        "keyRaw": "dateRangeDefaultValue",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "startDate": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "startDate",
                                                                                    "nullable": true,
                                                                                    "visible": true
                                                                                },

                                                                                "endDate": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "endDate",
                                                                                    "nullable": true,
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "typeMap": {}
                                                        },

                                                        "fragments": {
                                                            "FilterFragment": {
                                                                "arguments": {}
                                                            }
                                                        }
                                                    },

                                                    "abstract": true,
                                                    "visible": true
                                                },

                                                "notice": {
                                                    "type": "String",
                                                    "keyRaw": "notice",
                                                    "nullable": true,
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "currency": {
                            "type": "Currency",
                            "keyRaw": "currency",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=adb575272f57523e14243240b19b9f9fe0e2b58289c61c05372159c3e8a54567";